export enum PlatformContactTypeEnum {
	TENANT = 'tenant',
}
